import React from 'react'

import './SNHeader.scss'

const SNHeader = ({ children, type = 'primary' }) =>
    React.createElement('div', { className: `${type} SNHeader` }, [...children])

export default SNHeader
